namespace $ {

	export class $shm_hitalama_map_access_discovery extends $mol_object {

		@ $mol_mem
		static current() { return this.make({}) }

		catalog() {
			return this.$.$shm_hitalama_domain.instance().Map_access_catalog()?.remote() ?? null
		}

		auth() { return this.$.$giper_baza_auth.current() }

		@ $mol_mem_key
		rights( map: string ) {
			// Gift reads below bypass pawn accessors, so explicitly retain the native
			// land synchronizer. The wire maps of signed Gifts invalidate validation
			// on delivery, including a revoke without a matching registry update.
			return this.$.$giper_baza_glob.Land( new this.$.$giper_baza_link( map ) ).sync()
		}

		@ $mol_mem_key
		validate( item: { signer: $giper_baza_link, data: $shm_hitalama_map_access_invitation_data } ) {
			if( !item.data.active || item.data.recipient !== this.auth().pass().lord().str ) return null
			const rights = this.rights( item.data.map )
			// A cached registry can retain a removed service administrator. Check
			// its reactive signed rights too, not only the invitation's issuer.
			const catalog = item.data.backfill ? this.catalog() : null
			const registry = catalog ? this.rights( catalog.land().link().str ) : null
			if( !rights || !this.$.$shm_hitalama_map_access_invitation.granted( rights, item.signer, item.data, registry ) ) return null
			return item.data
		}

		@ $mol_mem
		entries() {
			const entries = new Map< string, $shm_hitalama_map_access_invitation_data >()
			for( const item of this.catalog()?.candidates( this.auth() ) ?? [] ) {
				const data = this.$.$mol_error_fence( ()=> this.validate( item ), ()=> null, ()=> null )
				if( data ) entries.set( data.map, data )
			}
			return entries
		}

	}

}
